import React from "react";

import BubbleMatrix from "./BubbleMatrix";
import { Modal } from "./Chrome";
import type { XFactorBriefingDetail } from "../../../Types/XFactorBriefing";
import type { XFactorPortfolioAccount } from "../../../Types/XFactorViewsRendering";

/**
 * The bubble matrix as reached from the ExecBridge flow's portfolio.
 *
 * Only the modal chrome and its two controls live here — the matrix itself is
 * `BubbleMatrix`, shared with the Temp Public Data tab under Always On
 * Intelligence so the two cannot drift apart.
 */
const BubbleMatrixModal: React.FC<{
  open: boolean;
  onClose: () => void;
  accounts: XFactorPortfolioAccount[];
  payloads: Record<string, { data: XFactorBriefingDetail | null }>;
  loading: boolean;
  onOpenBubble: (digestId: string, sectionId: string) => void;
}> = ({ open, onClose, accounts, payloads, loading, onOpenBubble }) => {
  const [showMetrics, setShowMetrics] = React.useState(false);
  const [legendOpen, setLegendOpen] = React.useState(true);

  return (
    <Modal
      open={open}
      onClose={onClose}
      width="max-w-7xl"
      title="Business Health · Bubble Chart"
      subtitle="Hover a bubble for its section score and synopsis. Click to open the section detail."
      actions={
        <div className="flex items-center gap-3">
          <label className="flex cursor-pointer items-center gap-1.5 text-xs text-gray-600">
            <input
              type="checkbox"
              checked={showMetrics}
              onChange={e => setShowMetrics(e.target.checked)}
              className="h-3.5 w-3.5 accent-[#ad46ff]"
            />
            Show metrics
          </label>
          <button
            type="button"
            onClick={() => setLegendOpen(o => !o)}
            className="text-xs font-medium text-[#ad46ff] hover:underline"
          >
            {legendOpen ? "Hide legend" : "Legend"}
          </button>
        </div>
      }
    >
      <BubbleMatrix
        accounts={accounts}
        payloads={payloads}
        loading={loading}
        onOpenBubble={onOpenBubble}
        showMetrics={showMetrics}
        showLegend={legendOpen}
      />
    </Modal>
  );
};

export default BubbleMatrixModal;
